import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { API, graphqlOperation } from "aws-amplify";
import CustomOverlay from "../../../components/CustomOverlay";
import FormSeller from "../../../components/forms/seller";
import { getSeller } from "../../../graphql/queries";
import { updateSeller } from "../../../graphql/mutations";

const EditSellerInfo = () => {
  const [overlay, setOverlay] = useState(true);
  const [currentUserInfo, setCurrentUserInfo] = useState({});
  const [sellerForm, setSellerForm] = useState({
    name: "",
    address: "",
    phone: "",
    postalFirst: "",
    postalSecond: "",
    invoiceRegistrationNumber: "",
  });
  const [registeredSeller, setRegisteredSeller] = useState(false);

  const fetchSellerInfo = async () => {
    try {
      const userInfo = await API.Auth.currentUserInfo();
      setCurrentUserInfo(userInfo);
  
      const response = await API.graphql({
        query: getSeller,
        variables: { id: userInfo.attributes.sub },
        authMode: 'AMAZON_COGNITO_USER_POOLS'
      });
      const seller = response.data.getSeller;
  
      if (seller) {
        if (seller.name && seller.address && seller.phone && seller.postal) {
          setRegisteredSeller(true);
          setSellerForm({
            ...seller,
            postalFirst: seller.postal.substr(0, 3),
            postalSecond: seller.postal.substr(-4),
            invoiceRegistrationNumber: seller.invoiceRegistrationNumber || "",
          });
        }
      }
  
      setOverlay(false);
    } catch (error) {
      console.error("Error fetching seller info:", error);
      setOverlay(false);
    }
  };
  
  useEffect(() => {
    fetchSellerInfo();
  }, []);
  
  const editSellerInfo = async () => {
    if (!sellerForm.name || !sellerForm.address || !sellerForm.phone || !sellerForm.postalFirst || !sellerForm.postalSecond) {
      alert("すべてのフィールドを入力してください。");
      return;
    }

    const updateInput = {
      id: String(currentUserInfo.attributes.sub),  // ←これ大事！
      name: sellerForm.name,
      address: sellerForm.address,
      phone: sellerForm.phone,
      postal: `${sellerForm.postalFirst}-${sellerForm.postalSecond}`,
      invoiceRegistrationNumber: sellerForm.invoiceRegistrationNumber || "",
    };

    try {
      setOverlay(true);
      const response = await API.graphql({
        query: updateSeller,
        variables: { input: updateInput },
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      }); 
      await fetchSellerInfo();
      alert("出品者情報を更新しました。");
      setOverlay(false);
    } catch (error) {
      console.error(error);
      alert(
        "出品者情報の更新に失敗しました。入力内容をご確認いただき、時間を置いてから再度お試しください"
      );
      setOverlay(false);
    }
  };

  return (
      <Box mx="auto" maxWidth={600}>
        <CustomOverlay overlay={overlay} />

        <Grid container justifyContent="center" style={{ marginBottom: "16px" }}>
          <Typography variant="h5">出品者情報の編集</Typography>
        </Grid>

        {registeredSeller ? (
          <Box>
            <FormSeller
              sellerForm={sellerForm}
              setSellerForm={setSellerForm}
              validateBtn="編集"
              onValidate={editSellerInfo}
            />
            <Grid container justifyContent="center" style={{ marginTop: "16px" }}>
              <Button
                variant="contained"
                color="default"
                component={Link}
                to="/profile"
              >
                プロフィールに戻る
              </Button>
            </Grid>
          </Box>
        ) : (
          <Box>
            <Grid container justifyContent="center" style={{ marginBottom: "16px" }}>
              <Typography variant="body1">
                出品者情報が登録されていません。<br />
                下のボタンをクリックして登録ページに進んで下さい。
              </Typography>
            </Grid>
            <Grid container justifyContent="center">
              <Button
                variant="contained"
                color="primary"
                component={Link}
                to="/profile/seller/new"
              >
                出品者情報を登録する
              </Button>
            </Grid>
          </Box>
        )}
      </Box>
  );
};

export default EditSellerInfo;